module.exports = "/shared/img/coins.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/coins.png
// module id = 410
// module chunks = 11